{
    "CmeList_Column_ID": "AUSWEIS",
    "CmeList_Column_Description": "Beschreibung",
    "CmeList_Column_ChildCMEs": "CMEs",
    "CmeList_Column_TelSyss": "Telefonieserver",
    "CmeList_Column_Partitions": "Partitionen",
    "CmeList_Column_Users": "Benutzer",
    "CmeList_CountLink_TelSyssAria": "Offene Telefonieserver, die für diese CM-Umgebung gefiltert werden",
    "CmeList_CountLink_PartitionsAria": "Offene Codes, die für diese CM-Umgebung gefiltert wurden",
    "CmeList_CountLink_UsersAria": "Benutzer der offenen Anwendung wurden für diese CM-Umgebung gefiltert.",
    "NAME": "CmeListLanguage"
}